import { render, staticRenderFns } from "./GroupsList.vue?vue&type=template&id=b51d9248&scoped=true"
import script from "./GroupsList.vue?vue&type=script&lang=ts"
export * from "./GroupsList.vue?vue&type=script&lang=ts"
import style0 from "./GroupsList.vue?vue&type=style&index=0&id=b51d9248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51d9248",
  null
  
)

export default component.exports